import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken } from "../Global";
// import { Logo, loader_image } from "../_components/Imagepath";
import { Logo } from "../_components/Imagepath";
// import $ from "jquery";

import AWS from 'aws-sdk';

import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION,AWS_BUCKET } from "../Global";

const QualityReportsView = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [permission, setPermission] = useState({});

  useEffect(() => {
        setPermission(FindModuleById(447)); 
        console.log(permission);

    axios
      .get(`/quality-report/view/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setValue(response.data.data.report);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  // const handleDownload = async () => {
  //   $("#loader-image").removeClass('loader-hide');
  //   $("#loader-image").addClass('loader-show');
  //   var barcode_number = value.barcode_number;
  //   axios.get(`/production-output/pdf/${id}`, {
  //     responseType: 'blob',
  //   headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }
  // }).then(response => {
  //     const blob = new Blob([response.data], { type: 'application/pdf' });
  //     const link = document.createElement('a');
  //     link.href = URL.createObjectURL(blob);
  //     let file_name = barcode_number +'.pdf';
  //     link.download = file_name;
  //     link.click();
  //     $("#loader-image").addClass('loader-hide');
  //       $("#loader-image").removeClass('loader-show');
  // })
  // .catch(error => {
  //     console.error('Error downloading PDF:', error);
  // });

  // };

  const viewFile =(link) =>{
    AWS.config.setPromisesDependency(); //use so you can promisify to get the actual images
    AWS.config.update({
    accessKeyId: AWS_ACCESS_KEY_ID,
    secretAccessKey: AWS_SECRET_ACCESS_KEY,
    region: AWS_DEFAULT_REGION,
    signatureVersion: 'v4',
    });
    const s3 = new AWS.S3();
    var params = {Bucket: AWS_BUCKET, Key: link};
    return  s3.getSignedUrl('getObject', params);
  }

  const th1 = {
    border: '2px solid #000', 
    borderLeft: '0px solid #000',  // Correct capitalization
    borderRight: '0px solid #000'  // Correct capitalization
};
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Quality Report</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/quality-reports">Quality Reports  </Link>
                    </li>
                    <li className="breadcrumb-item active">
                      View Quality Reports
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
            {permission && permission.list === 1 && (
                  <div className="col-md-12">
                  <div className="card">
                    <div className="card-body">

                    <div className="row">
                      <div className="col-md-2" style={{textAlign:'center'}}>
                      <img src={Logo} alt="Logo" width="100" height="100" />
                      </div>
                      <div className="col-md-10" style={{paddingTop:"10px"}}>
                        <h2>OUTBOUND QUALITY REPORT</h2>
                        <p>Frozen Fruits International S.A.R.L</p>
                      </div>
                      </div>

                      <br/><br/>
                      {/* <div style={{float:"right"}}>
                        <button   onClick={() => handleDownload()}   className="btn btn-primary me-1"  > Download Production Output <i className="fa fa-print" /> <img id="loader-image" className="loader-image loader-hide" src={loader_image}/>  </button>
                      </div> */}
                    
                    
                          <h2 style={{color:"#1B2E6B"}}>Details: </h2>
                        
                      
                      <table className="table table-bordered">
                        <tr style={th1}>
                          <td className="p-3">Sender</td>
                          <th className="p-3">{value.sender}</th>
                          <td className="p-3">Customer</td>
                          <th className="p-3">{value.customer}</th>
                        </tr>
                        <tr style={th1}>
                          <td className="p-3">Ref</td>
                          <th className="p-3">{value.ref}</th>
                          <td className="p-3">PO</td>
                          <th className="p-3"> {value.order_name}</th>
                        </tr>
                        <tr style={th1}>
                          <td className="p-3">Product</td>
                          <th className="p-3">{value.product}</th>
                          <td className="p-3">Loading type</td>
                          <th className="p-3">{value.loading_type}</th>
                        </tr>
                        <tr style={th1}>
                          <td className="p-3">Date</td>
                          <th className="p-3">{value.date}</th>
                          <td className="p-3">Container Number</td>
                          <th className="p-3">{value.container_number}</th>
                    
                        </tr>
                      


                  
                      </table>
                      <br /> <br /> <br />
                      <h3 className="card-title">Quality Control Report</h3>
                      <div className="row">
                      <div className="col-md-10">
                      <table className="table table-bordered">
                            <tr>
                                <th className="p-3">{'PO'}</th>
                                <th className="p-3">{'Ref'}</th>
                                <th className="p-3">Customer</th>
                                <th className="p-3">{'Loading date'}</th>
                              </tr>
                              <tr>
                                <th className="p-3"> {value.order_name}</th>
                                <th className="p-3">{value.ref}</th>
                                <th className="p-3">{value.customer}</th>
                                <th className="p-3">{value.date}</th>
                              </tr>
                      </table>

                      </div>
                      <div className="col-md-2">
                      <img src={Logo} alt="Logo" width="100" height="100" />
                      </div>
                      </div>
                      <br /> <br /> <br />
                      

                      <table className="table table-bordered">
                        

                        {value.items &&
                          value.items.map((item ,palletIndex)  => (
                            <tbody  key={item.product || palletIndex}>
                                <tr >
                                <td colSpan={4}><h3  style={{color:"#1B2E6B"}}>Sample# {palletIndex + 1}</h3></td>
                                
                              </tr>

                              <tr>
                                <td className="p-3">{'Product/Variety'}</td>
                                <th className="p-3">{item.product}</th>
                                <td className="p-3">Temperature °</td>
                                <th className="p-3">{item.temperature}</th>
                              </tr>
                              <tr>
                              
                                <td className="p-3">Sample weight (G) </td>
                                <th className="p-3">{item.sample_weight}(G)</th>
                                 <td className="p-3">{'Packaging'}</td>
                                <th className="p-3">  {item.consumable_name ? item.consumable_name : "Unknown"}</th>
                               
                              </tr>
                              
                            
                              <tr>
                                <td className="p-3">Lot number </td>
                                <th className="p-3">{item.lot_number}</th>
                                <td className="p-3">{'Country of origin'}</td>
                                <th className="p-3">{item.country}</th>
                              </tr>
                             
                              <tr>
                                
                                <td className="p-3">Label conformity  </td>
                                <th className="p-3">{item.label_conformity}</th>
                                <th colSpan={2}></th>
                              </tr>
                              <tr>
                                <td colSpan={4}><h3  style={{color:"#1B2E6B"}}>Quality Check#</h3></td>
                              </tr>
                               <tr>
                                <th className="p-3">{'Number Row'}</th>
                                <th className="p-3">{'Quality Default Row'}</th>
                                <th className="p-3">{'Quality default %'}</th>
                                <th className="p-3">{''}</th>
                              </tr>
                              {item.quality.map((item_1 ,i_i)  => (
                                <tr  key={i_i}>
                                <td className="p-3">{i_i+1}</td>
                                <td className="p-3">{item_1.name}</td>
                                <td className="p-3">{item_1.percentage}</td>
                                <td className="p-3">{''}</td>
                              </tr>
                              ))}

                              <tr>
                                <td colSpan={4}><h3  style={{color:"#1B2E6B"}}>Pictures#</h3></td>
                                
                              </tr>
                              <tr>
                                <th className="p-3">{item.images[0] && item.images[0].image && ( <img style={{width:'246px'}} src={viewFile(item.images[0].image) }/>)} </th>
                                <th className="p-3">{item.images[1] && item.images[1].image && ( <img style={{width:'246px'}} src={viewFile(item.images[1].image) }/>)} </th>
                                <th className="p-3">{item.images[2] && item.images[2].image && ( <img style={{width:'246px'}} src={viewFile(item.images[2].image) }/>)} </th>
                                <th className="p-3">{item.images[3] && item.images[3].image && ( <img style={{width:'246px'}} src={viewFile(item.images[3].image) }/>)} </th>
                              </tr>
                              <tr>
                                <th className="p-3">{item.images[4] && item.images[4].image && ( <img style={{width:'246px'}} src={viewFile(item.images[4].image) }/>)} </th>
                                <th className="p-3">{item.images[5] && item.images[5].image && ( <img style={{width:'246px'}} src={viewFile(item.images[5].image) }/>)} </th>
                              </tr>
                              
                            </tbody>
                            
                          ))}
                      </table>
                      <h3>Loading Conditions</h3>
                      <table>
                        <tr>
                           {value.loading_images && value.loading_images.map((item_11, iii)  => (
                              <td  key={iii}><img style={{width:'300px'}} src={viewFile(item_11.image) }/></td>
                              ))}
                        </tr>
                      </table>
                    </div>
                  </div>
                  </div>
                  )}
             
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default QualityReportsView;
